import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import { useOnComponentMount } from '../../../../../../../hooks/use-on-component-mount';
import Global from '../../../../../../../store/global-selectors';
import style from '../add-mfa-enrollment.module.less';

const PriorityPhoneCountryCodes = [
  {
    country: 'United States',
    code: '1',
    displayValue: 'US (+1)',
    selectedDisplayValue: '+1',
  },
  {
    country: 'United Kingdom',
    code: '44',
    displayValue: 'UK (+44)',
    selectedDisplayValue: '+44',
  },
];

const PhoneCountryCodes = [
  {
    country: 'Angola',
    code: '244',
    displayValue: 'AO (+244)',
    selectedDisplayValue: '+244',
  },
  {
    country: 'Anguilla',
    code: '1264',
    displayValue: 'AI (+1264)',
    selectedDisplayValue: '+1264',
  },
  {
    country: 'Antigua &amp; Barbuda',
    code: '1268',
    displayValue: 'AG (+1268)',
    selectedDisplayValue: '+1268',
  },
  {
    country: 'Argentina',
    code: '54',
    displayValue: 'AR (+54)',
    selectedDisplayValue: '+54',
  },
  {
    country: 'Armenia',
    code: '374',
    displayValue: 'AM (+374)',
    selectedDisplayValue: '+374',
  },
  {
    country: 'Aruba',
    code: '297',
    displayValue: 'AW (+297)',
    selectedDisplayValue: '+297',
  },
  {
    country: 'Australia',
    code: '61',
    displayValue: 'AU (+61)',
    selectedDisplayValue: '+61',
  },
  {
    country: 'Austria',
    code: '43',
    displayValue: 'AT (+43)',
    selectedDisplayValue: '+43',
  },
  {
    country: 'Azerbaijan',
    code: '994',
    displayValue: 'AZ (+994)',
    selectedDisplayValue: '+994',
  },
  {
    country: 'Bahamas',
    code: '1242',
    displayValue: 'BS (+1242)',
    selectedDisplayValue: '+1242',
  },
  {
    country: 'Bahrain',
    code: '973',
    displayValue: 'BH (+973)',
    selectedDisplayValue: '+973',
  },
  {
    country: 'Bangladesh',
    code: '880',
    displayValue: 'BD (+880)',
    selectedDisplayValue: '+880',
  },
  {
    country: 'Barbados',
    code: '1246',
    displayValue: 'BB (+1246)',
    selectedDisplayValue: '+1246',
  },
  {
    country: 'Belarus',
    code: '375',
    displayValue: 'BY (+375)',
    selectedDisplayValue: '+375',
  },
  {
    country: 'Belgium',
    code: '32',
    displayValue: 'BE (+32)',
    selectedDisplayValue: '+32',
  },
  {
    country: 'Belize',
    code: '501',
    displayValue: 'BZ (+501)',
    selectedDisplayValue: '+501',
  },
  {
    country: 'Benin',
    code: '229',
    displayValue: 'BJ (+229)',
    selectedDisplayValue: '+229',
  },
  {
    country: 'Bermuda',
    code: '1441',
    displayValue: 'BM (+1441)',
    selectedDisplayValue: '+1441',
  },
  {
    country: 'Bhutan',
    code: '975',
    displayValue: 'BT (+975)',
    selectedDisplayValue: '+975',
  },
  {
    country: 'Bolivia',
    code: '591',
    displayValue: 'BO (+591)',
    selectedDisplayValue: '+591',
  },
  {
    country: 'Bosnia Herzegovina',
    code: '387',
    displayValue: 'BA (+387)',
    selectedDisplayValue: '+387',
  },
  {
    country: 'Botswana',
    code: '267',
    displayValue: 'BW (+267)',
    selectedDisplayValue: '+267',
  },
  {
    country: 'Brazil',
    code: '55',
    displayValue: 'BR (+55)',
    selectedDisplayValue: '+55',
  },
  {
    country: 'Brunei',
    code: '673',
    displayValue: 'BN (+673)',
    selectedDisplayValue: '+673',
  },
  {
    country: 'Bulgaria',
    code: '359',
    displayValue: 'BG (+359)',
    selectedDisplayValue: '+359',
  },
  {
    country: 'Burkina Faso',
    code: '226',
    displayValue: 'BF (+226)',
    selectedDisplayValue: '+226',
  },
  {
    country: 'Burundi',
    code: '257',
    displayValue: 'BI (+257)',
    selectedDisplayValue: '+257',
  },
  {
    country: 'Cambodia',
    code: '855',
    displayValue: 'KH (+855)',
    selectedDisplayValue: '+855',
  },
  {
    country: 'Cameroon',
    code: '237',
    displayValue: 'CM (+237)',
    selectedDisplayValue: '+237',
  },
  {
    country: 'Canada',
    code: '1',
    displayValue: 'CA (+1)',
    selectedDisplayValue: '+1',
  },
  {
    country: 'Cape Verde Islands',
    code: '238',
    displayValue: 'CV (+238)',
    selectedDisplayValue: '+238',
  },
  {
    country: 'Cayman Islands',
    code: '1345',
    displayValue: 'KY (+1345)',
    selectedDisplayValue: '+1345',
  },
  {
    country: 'Central African Republic',
    code: '236',
    displayValue: 'CF (+236)',
    selectedDisplayValue: '+236',
  },
  {
    country: 'Chile',
    code: '56',
    displayValue: 'CL (+56)',
    selectedDisplayValue: '+56',
  },
  {
    country: 'China',
    code: '86',
    displayValue: 'CN (+86)',
    selectedDisplayValue: '+86',
  },
  {
    country: 'Colombia',
    code: '57',
    displayValue: 'CO (+57)',
    selectedDisplayValue: '+57',
  },
  {
    country: 'Comoros',
    code: '269',
    displayValue: 'KM (+269)',
    selectedDisplayValue: '+269',
  },
  {
    country: 'Congo',
    code: '242',
    displayValue: 'CG (+242)',
    selectedDisplayValue: '+242',
  },
  {
    country: 'Cook Islands',
    code: '682',
    displayValue: 'CK (+682)',
    selectedDisplayValue: '+682',
  },
  {
    country: 'Costa Rica',
    code: '506',
    displayValue: 'CR (+506)',
    selectedDisplayValue: '+506',
  },
  {
    country: 'Croatia',
    code: '385',
    displayValue: 'HR (+385)',
    selectedDisplayValue: '+385',
  },
  {
    country: 'Cuba',
    code: '53',
    displayValue: 'CU (+53)',
    selectedDisplayValue: '+53',
  },
  {
    country: 'Cyprus North',
    code: '90392',
    displayValue: 'CY (+90392)',
    selectedDisplayValue: '+90392',
  },
  {
    country: 'Cyprus South',
    code: '357',
    displayValue: 'CY (+357)',
    selectedDisplayValue: '+357',
  },
  {
    country: 'Czech Republic',
    code: '42',
    displayValue: 'CZ (+42)',
    selectedDisplayValue: '+42',
  },
  {
    country: 'Denmark',
    code: '45',
    displayValue: 'DK (+45)',
    selectedDisplayValue: '+45',
  },
  {
    country: 'Djibouti',
    code: '253',
    displayValue: 'DJ (+253)',
    selectedDisplayValue: '+253',
  },
  {
    country: 'Dominica',
    code: '1809',
    displayValue: 'DM (+1809)',
    selectedDisplayValue: '+1809',
  },
  {
    country: 'Dominican Republic',
    code: '1809',
    displayValue: 'DO (+1809)',
    selectedDisplayValue: '+1809',
  },
  {
    country: 'Ecuador',
    code: '593',
    displayValue: 'EC (+593)',
    selectedDisplayValue: '+593',
  },
  {
    country: 'Egypt',
    code: '20',
    displayValue: 'EG (+20)',
    selectedDisplayValue: '+20',
  },
  {
    country: 'El Salvador',
    code: '503',
    displayValue: 'SV (+503)',
    selectedDisplayValue: '+503',
  },
  {
    country: 'Equatorial Guinea',
    code: '240',
    displayValue: 'GQ (+240)',
    selectedDisplayValue: '+240',
  },
  {
    country: 'Eritrea',
    code: '291',
    displayValue: 'ER (+291)',
    selectedDisplayValue: '+291',
  },
  {
    country: 'Estonia',
    code: '372',
    displayValue: 'EE (+372)',
    selectedDisplayValue: '+372',
  },
  {
    country: 'Ethiopia',
    code: '251',
    displayValue: 'ET (+251)',
    selectedDisplayValue: '+251',
  },
  {
    country: 'Falkland Islands',
    code: '500',
    displayValue: 'FK (+500)',
    selectedDisplayValue: '+500',
  },
  {
    country: 'Faroe Islands',
    code: '298',
    displayValue: 'FO (+298)',
    selectedDisplayValue: '+298',
  },
  {
    country: 'Fiji',
    code: '679',
    displayValue: 'FJ (+679)',
    selectedDisplayValue: '+679',
  },
  {
    country: 'Finland',
    code: '358',
    displayValue: 'FI (+358)',
    selectedDisplayValue: '+358',
  },
  {
    country: 'France',
    code: '33',
    displayValue: 'FR (+33)',
    selectedDisplayValue: '+33',
  },
  {
    country: 'French Guiana',
    code: '594',
    displayValue: 'GF (+594)',
    selectedDisplayValue: '+594',
  },
  {
    country: 'French Polynesia',
    code: '689',
    displayValue: 'PF (+689)',
    selectedDisplayValue: '+689',
  },
  {
    country: 'Gabon',
    code: '241',
    displayValue: 'GA (+241)',
    selectedDisplayValue: '+241',
  },
  {
    country: 'Gambia',
    code: '220',
    displayValue: 'GM (+220)',
    selectedDisplayValue: '+220',
  },
  {
    country: 'Georgia',
    code: '7880',
    displayValue: 'GE (+7880)',
    selectedDisplayValue: '+7880',
  },
  {
    country: 'Germany',
    code: '49',
    displayValue: 'DE (+49)',
    selectedDisplayValue: '+49',
  },
  {
    country: 'Ghana',
    code: '233',
    displayValue: 'GH (+233)',
    selectedDisplayValue: '+233',
  },
  {
    country: 'Gibraltar',
    code: '350',
    displayValue: 'GI (+350)',
    selectedDisplayValue: '+350',
  },
  {
    country: 'Greece',
    code: '30',
    displayValue: 'GR (+30)',
    selectedDisplayValue: '+30',
  },
  {
    country: 'Greenland',
    code: '299',
    displayValue: 'GL (+299)',
    selectedDisplayValue: '+299',
  },
  {
    country: 'Grenada',
    code: '1473',
    displayValue: 'GD (+1473)',
    selectedDisplayValue: '+1473',
  },
  {
    country: 'Guadeloupe',
    code: '590',
    displayValue: 'GP (+590)',
    selectedDisplayValue: '+590',
  },
  {
    country: 'Guam',
    code: '671',
    displayValue: 'GU (+671)',
    selectedDisplayValue: '+671',
  },
  {
    country: 'Guatemala',
    code: '502',
    displayValue: 'GT (+502)',
    selectedDisplayValue: '+502',
  },
  {
    country: 'Guinea',
    code: '224',
    displayValue: 'GN (+224)',
    selectedDisplayValue: '+224',
  },
  {
    country: 'Guinea - Bissau',
    code: '245',
    displayValue: 'GW (+245)',
    selectedDisplayValue: '+245',
  },
  {
    country: 'Guyana',
    code: '592',
    displayValue: 'GY (+592)',
    selectedDisplayValue: '+592',
  },
  {
    country: 'Haiti',
    code: '509',
    displayValue: 'HT (+509)',
    selectedDisplayValue: '+509',
  },
  {
    country: 'Honduras',
    code: '504',
    displayValue: 'HN (+504)',
    selectedDisplayValue: '+504',
  },
  {
    country: 'Hong Kong',
    code: '852',
    displayValue: 'HK (+852)',
    selectedDisplayValue: '+852',
  },
  {
    country: 'Hungary',
    code: '36',
    displayValue: 'HU (+36)',
    selectedDisplayValue: '+36',
  },
  {
    country: 'Iceland',
    code: '354',
    displayValue: 'IS (+354)',
    selectedDisplayValue: '+354',
  },
  {
    country: 'India',
    code: '91',
    displayValue: 'IN (+91)',
    selectedDisplayValue: '+91',
  },
  {
    country: 'Indonesia',
    code: '62',
    displayValue: 'ID (+62)',
    selectedDisplayValue: '+62',
  },
  {
    country: 'Iran',
    code: '98',
    displayValue: 'IR (+98)',
    selectedDisplayValue: '+98',
  },
  {
    country: 'Iraq',
    code: '964',
    displayValue: 'IQ (+964)',
    selectedDisplayValue: '+964',
  },
  {
    country: 'Ireland',
    code: '353',
    displayValue: 'IE (+353)',
    selectedDisplayValue: '+353',
  },
  {
    country: 'Israel',
    code: '972',
    displayValue: 'IL (+972)',
    selectedDisplayValue: '+972',
  },
  {
    country: 'Italy',
    code: '39',
    displayValue: 'IT (+39)',
    selectedDisplayValue: '+39',
  },
  {
    country: 'Jamaica',
    code: '1876',
    displayValue: 'JM (+1876)',
    selectedDisplayValue: '+1876',
  },
  {
    country: 'Japan',
    code: '81',
    displayValue: 'JP (+81)',
    selectedDisplayValue: '+81',
  },
  {
    country: 'Jordan',
    code: '962',
    displayValue: 'JO (+962)',
    selectedDisplayValue: '+962',
  },
  {
    country: 'Kazakhstan',
    code: '7',
    displayValue: 'KZ (+7)',
    selectedDisplayValue: '+7',
  },
  {
    country: 'Kenya',
    code: '254',
    displayValue: 'KE (+254)',
    selectedDisplayValue: '+254',
  },
  {
    country: 'Kiribati',
    code: '686',
    displayValue: 'KI (+686)',
    selectedDisplayValue: '+686',
  },
  {
    country: 'Korea North',
    code: '850',
    displayValue: 'KP (+850)',
    selectedDisplayValue: '+850',
  },
  {
    country: 'Korea South',
    code: '82',
    displayValue: 'KR (+82)',
    selectedDisplayValue: '+82',
  },
  {
    country: 'Kuwait',
    code: '965',
    displayValue: 'KW (+965)',
    selectedDisplayValue: '+965',
  },
  {
    country: 'Kyrgyzstan',
    code: '996',
    displayValue: 'KG (+996)',
    selectedDisplayValue: '+996',
  },
  {
    country: 'Laos',
    code: '856',
    displayValue: 'LA (+856)',
    selectedDisplayValue: '+856',
  },
  {
    country: 'Latvia',
    code: '371',
    displayValue: 'LV (+371)',
    selectedDisplayValue: '+371',
  },
  {
    country: 'Lebanon',
    code: '961',
    displayValue: 'LB (+961)',
    selectedDisplayValue: '+961',
  },
  {
    country: 'Lesotho',
    code: '266',
    displayValue: 'LS (+266)',
    selectedDisplayValue: '+266',
  },
  {
    country: 'Liberia',
    code: '231',
    displayValue: 'LR (+231)',
    selectedDisplayValue: '+231',
  },
  {
    country: 'Libya',
    code: '218',
    displayValue: 'LY (+218)',
    selectedDisplayValue: '+218',
  },
  {
    country: 'Liechtenstein',
    code: '417',
    displayValue: 'LI (+417)',
    selectedDisplayValue: '+417',
  },
  {
    country: 'Lithuania',
    code: '370',
    displayValue: 'LT (+370)',
    selectedDisplayValue: '+370',
  },
  {
    country: 'Luxembourg',
    code: '352',
    displayValue: 'LU (+352)',
    selectedDisplayValue: '+352',
  },
  {
    country: 'Macao',
    code: '853',
    displayValue: 'MO (+853)',
    selectedDisplayValue: '+853',
  },
  {
    country: 'Macedonia',
    code: '389',
    displayValue: 'MK (+389)',
    selectedDisplayValue: '+389',
  },
  {
    country: 'Madagascar',
    code: '261',
    displayValue: 'MG (+261)',
    selectedDisplayValue: '+261',
  },
  {
    country: 'Malawi',
    code: '265',
    displayValue: 'MW (+265)',
    selectedDisplayValue: '+265',
  },
  {
    country: 'Malaysia',
    code: '60',
    displayValue: 'MY (+60)',
    selectedDisplayValue: '+60',
  },
  {
    country: 'Maldives',
    code: '960',
    displayValue: 'MV (+960)',
    selectedDisplayValue: '+960',
  },
  {
    country: 'Mali',
    code: '223',
    displayValue: 'ML (+223)',
    selectedDisplayValue: '+223',
  },
  {
    country: 'Malta',
    code: '356',
    displayValue: 'MT (+356)',
    selectedDisplayValue: '+356',
  },
  {
    country: 'Marshall Islands',
    code: '692',
    displayValue: 'MH (+692)',
    selectedDisplayValue: '+692',
  },
  {
    country: 'Martinique',
    code: '596',
    displayValue: 'MQ (+596)',
    selectedDisplayValue: '+596',
  },
  {
    country: 'Mauritania',
    code: '222',
    displayValue: 'MR (+222)',
    selectedDisplayValue: '+222',
  },
  {
    country: 'Mayotte',
    code: '269',
    displayValue: 'YT (+269)',
    selectedDisplayValue: '+269',
  },
  {
    country: 'Mexico',
    code: '52',
    displayValue: 'MX (+52)',
    selectedDisplayValue: '+52',
  },
  {
    country: 'Micronesia',
    code: '691',
    displayValue: 'FM (+691)',
    selectedDisplayValue: '+691',
  },
  {
    country: 'Moldova',
    code: '373',
    displayValue: 'MD (+373)',
    selectedDisplayValue: '+373',
  },
  {
    country: 'Monaco',
    code: '377',
    displayValue: 'MC (+377)',
    selectedDisplayValue: '+377',
  },
  {
    country: 'Mongolia',
    code: '976',
    displayValue: 'MN (+976)',
    selectedDisplayValue: '+976',
  },
  {
    country: 'Montserrat',
    code: '1664',
    displayValue: 'MS (+1664)',
    selectedDisplayValue: '+1664',
  },
  {
    country: 'Morocco',
    code: '212',
    displayValue: 'MA (+212)',
    selectedDisplayValue: '+212',
  },
  {
    country: 'Mozambique',
    code: '258',
    displayValue: 'MZ (+258)',
    selectedDisplayValue: '+258',
  },
  {
    country: 'Myanmar',
    code: '95',
    displayValue: 'MN (+95)',
    selectedDisplayValue: '+95',
  },
  {
    country: 'Namibia',
    code: '264',
    displayValue: 'NA (+264)',
    selectedDisplayValue: '+264',
  },
  {
    country: 'Nauru',
    code: '674',
    displayValue: 'NR (+674)',
    selectedDisplayValue: '+674',
  },
  {
    country: 'Nepal',
    code: '977',
    displayValue: 'NP (+977)',
    selectedDisplayValue: '+977',
  },
  {
    country: 'Netherlands',
    code: '31',
    displayValue: 'NL (+31)',
    selectedDisplayValue: '+31',
  },
  {
    country: 'New Caledonia',
    code: '687',
    displayValue: 'NC (+687)',
    selectedDisplayValue: '+687',
  },
  {
    country: 'New Zealand',
    code: '64',
    displayValue: 'NZ (+64)',
    selectedDisplayValue: '+64',
  },
  {
    country: 'Nicaragua',
    code: '505',
    displayValue: 'NI (+505)',
    selectedDisplayValue: '+505',
  },
  {
    country: 'Niger',
    code: '227',
    displayValue: 'NE (+227)',
    selectedDisplayValue: '+227',
  },
  {
    country: 'Nigeria',
    code: '234',
    displayValue: 'NG (+234)',
    selectedDisplayValue: '+234',
  },
  {
    country: 'Niue',
    code: '683',
    displayValue: 'NU (+683)',
    selectedDisplayValue: '+683',
  },
  {
    country: 'Norfolk Islands',
    code: '672',
    displayValue: 'NF (+672)',
    selectedDisplayValue: '+672',
  },
  {
    country: 'Northern Marianas',
    code: '670',
    displayValue: 'NP (+670)',
    selectedDisplayValue: '+670',
  },
  {
    country: 'Norway',
    code: '47',
    displayValue: 'NO (+47)',
    selectedDisplayValue: '+47',
  },
  {
    country: 'Oman',
    code: '968',
    displayValue: 'OM (+968)',
    selectedDisplayValue: '+968',
  },
  {
    country: 'Palau',
    code: '680',
    displayValue: 'PW (+680)',
    selectedDisplayValue: '+680',
  },
  {
    country: 'Palestine',
    code: '970',
    displayValue: 'PSE (+970)',
    selectedDisplayValue: '+970',
  },
  {
    country: 'Panama',
    code: '507',
    displayValue: 'PA (+507)',
    selectedDisplayValue: '+507',
  },
  {
    country: 'Papua New Guinea',
    code: '675',
    displayValue: 'PG (+675)',
    selectedDisplayValue: '+675',
  },
  {
    country: 'Paraguay',
    code: '595',
    displayValue: 'PY (+595)',
    selectedDisplayValue: '+595',
  },
  {
    country: 'Peru',
    code: '51',
    displayValue: 'PE (+51)',
    selectedDisplayValue: '+51',
  },
  {
    country: 'Philippines',
    code: '63',
    displayValue: 'PH (+63)',
    selectedDisplayValue: '+63',
  },
  {
    country: 'Poland',
    code: '48',
    displayValue: 'PL (+48)',
    selectedDisplayValue: '+48',
  },
  {
    country: 'Portugal',
    code: '351',
    displayValue: 'PT (+351)',
    selectedDisplayValue: '+351',
  },
  {
    country: 'Puerto Rico',
    code: '1787',
    displayValue: 'PR (+1787)',
    selectedDisplayValue: '+1787',
  },
  {
    country: 'Qatar',
    code: '974',
    displayValue: 'QA (+974)',
    selectedDisplayValue: '+974',
  },
  {
    country: 'Reunion',
    code: '262',
    displayValue: 'RE (+262)',
    selectedDisplayValue: '+262',
  },
  {
    country: 'Romania',
    code: '40',
    displayValue: 'RO (+40)',
    selectedDisplayValue: '+40',
  },
  {
    country: 'Russia',
    code: '7',
    displayValue: 'RU (+7)',
    selectedDisplayValue: '+7',
  },
  {
    country: 'Rwanda',
    code: '250',
    displayValue: 'RW (+250)',
    selectedDisplayValue: '+250',
  },
  {
    country: 'San Marino',
    code: '378',
    displayValue: 'SM (+378)',
    selectedDisplayValue: '+378',
  },
  {
    country: 'Sao Tome &amp; Principe',
    code: '239',
    displayValue: 'ST (+239)',
    selectedDisplayValue: '+239',
  },
  {
    country: 'Saudi Arabia',
    code: '966',
    displayValue: 'SA (+966)',
    selectedDisplayValue: '+966',
  },
  {
    country: 'Senegal',
    code: '221',
    displayValue: 'SN (+221)',
    selectedDisplayValue: '+221',
  },
  {
    country: 'Serbia',
    code: '381',
    displayValue: 'CS (+381)',
    selectedDisplayValue: '+381',
  },
  {
    country: 'Seychelles',
    code: '248',
    displayValue: 'SC (+248)',
    selectedDisplayValue: '+248',
  },
  {
    country: 'Sierra Leone',
    code: '232',
    displayValue: 'SL (+232)',
    selectedDisplayValue: '+232',
  },
  {
    country: 'Singapore',
    code: '65',
    displayValue: 'SG (+65)',
    selectedDisplayValue: '+65',
  },
  {
    country: 'Slovak Republic',
    code: '421',
    displayValue: 'SK (+421)',
    selectedDisplayValue: '+421',
  },
  {
    country: 'Slovenia',
    code: '386',
    displayValue: 'SI (+386)',
    selectedDisplayValue: '+386',
  },
  {
    country: 'Solomon Islands',
    code: '677',
    displayValue: 'SB (+677)',
    selectedDisplayValue: '+677',
  },
  {
    country: 'Somalia',
    code: '252',
    displayValue: 'SO (+252)',
    selectedDisplayValue: '+252',
  },
  {
    country: 'South Africa',
    code: '27',
    displayValue: 'ZA (+27)',
    selectedDisplayValue: '+27',
  },
  {
    country: 'Spain',
    code: '34',
    displayValue: 'ES (+34)',
    selectedDisplayValue: '+34',
  },
  {
    country: 'Sri Lanka',
    code: '94',
    displayValue: 'LK (+94)',
    selectedDisplayValue: '+94',
  },
  {
    country: 'St. Helena',
    code: '290',
    displayValue: 'SH (+290)',
    selectedDisplayValue: '+290',
  },
  {
    country: 'St. Kitts',
    code: '1869',
    displayValue: 'KN (+1869)',
    selectedDisplayValue: '+1869',
  },
  {
    country: 'St. Lucia',
    code: '1758',
    displayValue: 'SC (+1758)',
    selectedDisplayValue: '+1758',
  },
  {
    country: 'Sudan',
    code: '249',
    displayValue: 'SD (+249)',
    selectedDisplayValue: '+249',
  },
  {
    country: 'Suriname',
    code: '597',
    displayValue: 'SR (+597)',
    selectedDisplayValue: '+597',
  },
  {
    country: 'Swaziland',
    code: '268',
    displayValue: 'SZ (+268)',
    selectedDisplayValue: '+268',
  },
  {
    country: 'Sweden',
    code: '46',
    displayValue: 'SE (+46)',
    selectedDisplayValue: '+46',
  },
  {
    country: 'Switzerland',
    code: '41',
    displayValue: 'CH (+41)',
    selectedDisplayValue: '+41',
  },
  {
    country: 'Syria',
    code: '963',
    displayValue: 'SI (+963)',
    selectedDisplayValue: '+963',
  },
  {
    country: 'Taiwan',
    code: '886',
    displayValue: 'TW (+886)',
    selectedDisplayValue: '+886',
  },
  {
    country: 'Tajikstan',
    code: '7',
    displayValue: 'TJ (+7)',
    selectedDisplayValue: '+7',
  },
  {
    country: 'Thailand',
    code: '66',
    displayValue: 'TH (+66)',
    selectedDisplayValue: '+66',
  },
  {
    country: 'Togo',
    code: '228',
    displayValue: 'TG (+228)',
    selectedDisplayValue: '+228',
  },
  {
    country: 'Tonga',
    code: '676',
    displayValue: 'TO (+676)',
    selectedDisplayValue: '+676',
  },
  {
    country: 'Trinidad &amp; Tobago',
    code: '1868',
    displayValue: 'TT (+1868)',
    selectedDisplayValue: '+1868',
  },
  {
    country: 'Tunisia',
    code: '216',
    displayValue: 'TN (+216)',
    selectedDisplayValue: '+216',
  },
  {
    country: 'Turkey',
    code: '90',
    displayValue: 'TR (+90)',
    selectedDisplayValue: '+90',
  },
  {
    country: 'Turkmenistan',
    code: '7',
    displayValue: 'TM (+7)',
    selectedDisplayValue: '+7',
  },
  {
    country: 'Turkmenistan',
    code: '993',
    displayValue: 'TM (+993)',
    selectedDisplayValue: '+993',
  },
  {
    country: 'Turks &amp; Caicos Islands',
    code: '1649',
    displayValue: 'TC (+1649)',
    selectedDisplayValue: '+1649',
  },
  {
    country: 'Tuvalu',
    code: '688',
    displayValue: 'TV (+688)',
    selectedDisplayValue: '+688',
  },
  {
    country: 'Uganda',
    code: '256',
    displayValue: 'UG (+256)',
    selectedDisplayValue: '+256',
  },
  {
    country: 'Ukraine',
    code: '380',
    displayValue: 'UA (+380)',
    selectedDisplayValue: '+380',
  },
  {
    country: 'United Arab Emirates',
    code: '971',
    displayValue: 'AE (+971)',
    selectedDisplayValue: '+971',
  },
  {
    country: 'Uruguay',
    code: '598',
    displayValue: 'UY (+598)',
    selectedDisplayValue: '+598',
  },
  {
    country: 'Uzbekistan',
    code: '7',
    displayValue: 'UZ (+7)',
    selectedDisplayValue: '+7',
  },
  {
    country: 'Vanuatu',
    code: '678',
    displayValue: 'VU (+678)',
    selectedDisplayValue: '+678',
  },
  {
    country: 'Vatican City',
    code: '379',
    displayValue: 'VA (+379)',
    selectedDisplayValue: '+379',
  },
  {
    country: 'Venezuela',
    code: '58',
    displayValue: 'VE (+58)',
    selectedDisplayValue: '+58',
  },
  {
    country: 'Vietnam',
    code: '84',
    displayValue: 'VN (+84)',
    selectedDisplayValue: '+84',
  },
  {
    country: 'Virgin Islands - British',
    code: '84',
    displayValue: 'VG (+1284)',
    selectedDisplayValue: '+1284',
  },
  {
    country: 'Virgin Islands - US',
    code: '84',
    displayValue: 'VI (+1340)',
    selectedDisplayValue: '+1340',
  },
  {
    country: 'Wallis &amp; Futuna',
    code: '681',
    displayValue: 'WF (+681)',
    selectedDisplayValue: '+681',
  },
  {
    country: 'Yemen',
    code: '967',
    displayValue: 'YE (+967)',
    selectedDisplayValue: '+967',
  },
  {
    country: 'Zambia',
    code: '260',
    displayValue: 'ZM (+260)',
    selectedDisplayValue: '+260',
  },
  {
    country: 'Zimbabwe',
    code: '263',
    displayValue: 'ZW (+263)',
    selectedDisplayValue: '+263',
  },
];

const AllCountryCodes = [...PriorityPhoneCountryCodes, ...PhoneCountryCodes.sort((a, b) => a.displayValue - b.displayValue)];

export const CountryCodeSelect = ({ setCountryCode, selectedCode }) => {
  const sellerHomeCountry = useSelector(Global.selectSellerHomeCountry);

  const defaultSelection = AllCountryCodes.find((country) => country.displayValue.includes(sellerHomeCountry));

  useOnComponentMount(() => {
    setCountryCode(defaultSelection);
  });

  const onClick = useCallback(
    (args) => {
      setCountryCode(args);
    },
    [setCountryCode],
  );

  return (
    <DropdownMenu className={style['country-code-input']}>
      <DropdownMenuToggler theme='white-outlined'>{selectedCode?.selectedDisplayValue}</DropdownMenuToggler>
      {AllCountryCodes.map((phoneCountryCode) => (
        <DropdownMenuItem
          key={phoneCountryCode.displayValue}
          name={phoneCountryCode}
          onClick={onClick}
          selected={selectedCode === phoneCountryCode}
        >
          {phoneCountryCode.displayValue}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};
